/* eslint-disable */
import { format } from 'date-fns';
// import { useEffect } from 'react';
import { connect } from 'react-redux';
import { formActions } from '../../../Actions';
import { AiHistoryFinder } from '../../../Components/Forms/AiHistoryFinder';
import { ListTable } from '../../../Components/ListTable';
// import { DATE_FORMAT } from '../../../Constants';
import styles from './AIModelHistoryPage.module.css';
import { Button, Chip } from '@mui/material';
import { Filter } from 'lucide-react';
import drawerActions from '@/Actions/drawer.actions';
import ImagesFinder from '@/Components/ImagesFinder/ImagesFinder';
import { filtersInfoChip, handleResponseStreamDownload } from '@/Helpers';
import { useState } from 'react';
import moment from 'moment';

const COLMAP = {
	'Model Type': 'modelType',
	Mode: 'imsMode',
	Store: 'storeName',
	Product: 'productName',
	'Created At': 'createdAt',
	Status: 'status',
	User: 'user',
	'Updated At': 'updatedAt',
};

const AiDateFormat = 'yyyy-MM-dd';
const TABLE_COLUMNS = [
	{
		title: 'Model Type',
		config: {
			type: 'DATA',
		},
	},
	// {
	// 	title: 'Store',
	// 	config: {
	// 		type: 'DATA',
	// 	},
	// },
	{
		title: 'Mode',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Product',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Created At',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Status',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'User',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Updated At',
		config: {
			type: 'DATA',
		},
	},
];

function AIModelHistoryPage(props) {
	const {
		fetchModelHistory,
		data,
		toggleFiltersDrawer,
		// fetchStoresList
	} = props;

	const [filters, setFilters] = useState({});
	const fetchHistoryData = (filters) => {
		const { from, to } = filters?.dateRange;
		const { customerId: clientId } = JSON.parse(
			localStorage.getItem('appConfig')
		);
		setFilters(filters);

		fetchModelHistory({
			entity: 'AI_MODEL',
			method: 'LIST',
			showNotification: true,
			req: {
				data: {
					clientId,
					store: [],
					model: filters?.type,
					startDate: format(from, AiDateFormat),
					endDate: format(to, AiDateFormat),
				},
			},
		});
	};

	// useEffect(() => {
	// 	fetchStoresList({
	// 		entity: 'STORES',
	// 		req: {
	// 			params: {
	// 				id: '',
	// 			},
	// 		},
	// 		method: 'LIST',
	// 	});
	// }, []);

	const filtersInfo = {
		header: {
			date: false,
			statusAndTypes: false,
		},
		dateRangeOnly: {
			show: true,
		},
		type: {
			text: 'Model Type',
			show: true,
			list: [
				{
					type: 'FACE',
					label: 'FACE',
				},
				{
					type: 'FOOD-FEATURE',
					label: 'FOOD FEATURE',
				},
				{
					type: 'FOOD-IDENTIFICATION',
					label: 'FOOD IDENTIFICATION',
				},
			]
		}
	};

	const exportInfo = {
		showExportBtn : true,
	};

	const handleExportData = () => {
		// Prepare headers from COLMAP
		const headers = TABLE_COLUMNS.map(col => col.title);
		
		// Prepare rows from data using COLMAP
		const rows = data?.map(item => {
			return headers.map(header => {
				const value = item[COLMAP[header]];
				return value || '-';
			});
		});

		// Combine headers and rows
		const csvData = [headers, ...rows];

		// Generate filename with timestamp
		const timestamp = format(new Date(), 'yyyy-MM-dd');
		const filename = `ai-model-history-${timestamp}.csv`;

		// Download CSV
		const csvContent = csvData.map(row => row.join(',')).join('\n');
		const csvFile = new Blob([csvContent], { type: 'text/csv' });
		
		// Create download link
		const downloadLink = document.createElement('a');
		downloadLink.download = filename;
		downloadLink.href = window.URL.createObjectURL(csvFile);
		downloadLink.style.display = 'none';
		
		// Add to DOM, trigger click, then clean up
		document.body.appendChild(downloadLink);
		downloadLink.click();
		window.URL.revokeObjectURL(downloadLink.href);
		document.body.removeChild(downloadLink);
	};

	return (
		<div className={styles.root}>
			<ImagesFinder
				onSubmit={fetchHistoryData}
				defaultState={{
					DATE_RANGE: {
						active: true,
						from: new Date(),
						to: new Date(),
					},
				}}
				filtersInfo={filtersInfo}
				exportInfo={exportInfo}
			/>
			<div className='flex justify-between w-full items-center'>
			<span className='font-bold text-[16px] ml-1'>AI Model History</span>
			<Button
					onClick={() => {
						toggleFiltersDrawer(true, {
							exportFrontend : true,
							handleExportFrontend : handleExportData,
						});
					}}
					className='m-2 px-4 py-2 text-white bg-teal-600 border border-gray-300 rounded-md hover:bg-teal-700'
				>
					<span className='text-nowrap'>Filter and Export</span>
					<Filter className='size-4' />
			</Button>
			</div>
			{filtersInfoChip(filtersInfo, filters)}
			<ListTable
				hasDateRange
				colMap={COLMAP}
				columns={TABLE_COLUMNS}
				data={data}
				actions={[]}
				special={{}}
				showBtnContainer={false}
			/>
		</div>
	);
}

const mapStateToProps = (state) => {
	const { LIST } = state.form.AI_MODEL.data;
	const { DATE_RANGE_FILTER: dateRangeFilter } = state.analytics;
	return {
		data: LIST,
		dateRangeFilter,
	};
};

const mapDispatchToProps = {
	fetchModelHistory: formActions.gateway,
	toggleFiltersDrawer: drawerActions.toggleFiltersDrawer,
	// fetchStoresList: formActions.gateway,
};

export default connect(mapStateToProps, mapDispatchToProps)(AIModelHistoryPage);
